import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import Achievements from './components/Achievements/Achievements';
import Contact from './components/Contact/Contact';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import { initAnalytics, trackPageView } from './utils/analyticsService';

function App() {
  const [loading, setLoading] = useState(true);

  const handleLoadingComplete = () => {
    setLoading(false);
  };
  
  // Initialize analytics and track page view
  useEffect(() => {
    // Initialize analytics
    initAnalytics();
    
    // Track page view after a short delay
    const timer = setTimeout(() => {
      trackPageView();
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <LoadingScreen onComplete={handleLoadingComplete} />
      ) : (
        <>
          <Navbar />
          <Hero />
          <About />
          <Projects />
          <Achievements />
          
          <Skills />
          
          <Contact />
          <ScrollToTop />
        </>
      )}
    </div>
  );
}

export default App;